export default __webpack_public_path__ + "static/media/coffeeBackground.19d9d36a.jpg";